import { LoadingButton } from "@mui/lab";
import {
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import {
  addReadySolutions,
  addWorkManagement,
  getLandingPage,
} from "src/DAL/landingPage";
import { _upload_file } from "src/DAL/uploads";
import {
  CircularLoader,
  Iconify,
  MuiDialog,
  Page,
  RichEditor,
  Scrollbar,
} from "src/components";
import { s3baseUrl } from "src/config/config";

function WorkManagement() {
  const { enqueueSnackbar } = useSnackbar();
  const [workManagementData, setWorkManagementData] = useState();
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [addMenuitemDialogOpen, setAddMenuitemDialogOpen] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [editIndex, setEditIndex] = useState();
  const [newMenuItem, setNewMenuItem] = useState({
    image: "",
    file: null,
    blob: "",
    title: "",
    description: "",
    tab_bar_text: "",
    tab_bar_image: "",
    tabFile: null,
    tabBlob: "",
    learn_more_button: {
      text: "",
      link: "",
    },
  });
  const [deleteLogoDialog, setDeleteLogoDialog] = useState(false);
  const openDelete = () => {
    setDeleteLogoDialog(true);
  };
  const closeDelete = () => {
    setDeleteLogoDialog(false);
    setEditIndex();
  };
  const confirmDelete = () => {
    setWorkManagementData((prev) => {
      return {
        ...prev,
        steps: prev.steps.filter((item, i) => i !== editIndex),
      };
    });
    closeDelete();
  };
  const openAddItemDialog = () => {
    setAddMenuitemDialogOpen(true);
  };
  const closeAddItemDialog = () => {
    setAddMenuitemDialogOpen(false);
    setNewMenuItem({
      image: "",
      file: null,
      blob: "",
      title: "",
      description: "",
      tab_bar_text: "",
      tab_bar_image: "",
      tabFile: null,
      tabBlob: "",
      learn_more_button: {
        text: "",
        link: "",
      },
    });
    setIsEditing(false);
    setEditIndex();
  };
  const getLandingPageData = async () => {
    try {
      const result = await getLandingPage();
      if (result.code == 200) {
        setWorkManagementData({
          ...result.data.work_management,
          steps: result.data.work_management.steps.map((item) => {
            return {
              ...item,
              file: null,
              blob: "",
              tabFile: null,
              tabBlob: "",
            };
          }),
        });
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      setLoading(false);
    }
  };
  const handleAddData = () => {
    setWorkManagementData((prev) => {
      return {
        ...prev,
        steps: [...prev.steps, newMenuItem],
      };
    });
    closeAddItemDialog();
  };
  const handleEditData = () => {
    setWorkManagementData((prev) => {
      let temp_menu = prev.steps;
      temp_menu[editIndex] = newMenuItem;
      return {
        ...prev,
        steps: [...temp_menu],
      };
    });
    closeAddItemDialog();
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoadingBtn(true);
      let data = workManagementData;
      let logos = data.steps;
      for (let i = 0; i < logos.length; i++) {
        if (logos[i].file) {
          const formData = new FormData();
          formData.append("directory", "images/");
          formData.append("upload_file", logos[i].file);
          const imgResult = await _upload_file(formData);
          if (imgResult.code == 200) {
            logos[i]["image"] = imgResult.path;
          }
        }
        if (logos[i].tabFile) {
          const formData = new FormData();
          formData.append("directory", "images/");
          formData.append("upload_file", logos[i].tabFile);
          const imgResult = await _upload_file(formData);
          if (imgResult.code == 200) {
            logos[i]["tab_bar_image"] = imgResult.path;
          }
        }
        delete logos[i].file;
        delete logos[i].blob;
        delete logos[i].tabBlob;
        delete logos[i].tabFile;
        if (logos[i]._id) {
          delete logos[i]._id;
        }
      }
      data["steps"] = logos;
      const result = await addWorkManagement(data);
      enqueueSnackbar(result.message, {
        variant: result.code == 200 ? "success" : "error",
      });
      if (result.code == 200) {
        setWorkManagementData(result.data.work_management);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingBtn(false);
    }
  };
  useEffect(() => {
    getLandingPageData();
  }, []);
  if (loading) {
    return <CircularLoader />;
  }
  return (
    <Page title="Work Management">
      <Container maxWidth="xl">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={4.5}
        >
          <Typography variant="h4">Work Management</Typography>
        </Stack>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <RichEditor
                placeHolder="Title"
                value={workManagementData.title}
                setValue={(val) =>
                  setWorkManagementData((prev) => {
                    return { ...prev, title: val };
                  })
                }
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <TextField
                  label="Get started button text"
                  value={workManagementData.get_started_button.text}
                  onChange={(e) =>
                    setWorkManagementData((prev) => {
                      return {
                        ...prev,
                        get_started_button: {
                          ...prev.get_started_button,
                          text: e.target.value,
                        },
                      };
                    })
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <TextField
                  label="Get started button link"
                  value={workManagementData.get_started_button.link}
                  onChange={(e) =>
                    setWorkManagementData((prev) => {
                      return {
                        ...prev,
                        get_started_button: {
                          ...prev.get_started_button,
                          link: e.target.value,
                        },
                      };
                    })
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} mt={5}>
              <Button onClick={openAddItemDialog}>Add Step</Button>
            </Grid>
            <Grid item xs={12}>
              <Scrollbar>
                <TableContainer minWidth={800}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Step Title</TableCell>
                        <TableCell>Step Description</TableCell>
                        <TableCell>Step learn more button Text</TableCell>
                        <TableCell>Step learn more button Link</TableCell>
                        <TableCell>Step Image</TableCell>
                        <TableCell>tab bar text</TableCell>
                        <TableCell>tab bar image</TableCell>
                        <TableCell>Edit</TableCell>
                        <TableCell>Delete</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {workManagementData?.steps?.map((val, i) => {
                        return (
                          <>
                            <TableRow>
                              <TableCell>{val.title}</TableCell>
                              <TableCell>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: val.description,
                                  }}
                                />
                              </TableCell>
                              <TableCell>
                                {val.learn_more_button.text}
                              </TableCell>
                              <TableCell>
                                {val.learn_more_button.link}
                              </TableCell>
                              <TableCell>
                                <img
                                  style={{ width: "4.5rem", height: "2.5rem" }}
                                  src={
                                    val.blob ? val.blob : s3baseUrl + val.image
                                  }
                                  alt=""
                                />
                              </TableCell>
                              <TableCell>{val.tab_bar_text}</TableCell>
                              <TableCell>
                                <img
                                  style={{ width: "4.5rem", height: "2.5rem" }}
                                  src={
                                    val.tabBlob
                                      ? val.tabBlob
                                      : s3baseUrl + val.tab_bar_image
                                  }
                                  alt=""
                                />
                              </TableCell>
                              <TableCell>
                                <Iconify
                                  onClick={() => {
                                    setIsEditing(true);
                                    setEditIndex(i);
                                    setNewMenuItem(val);
                                    openAddItemDialog();
                                  }}
                                  style={{ color: "green", cursor: "pointer" }}
                                  icon={"fa-regular:edit"}
                                />
                              </TableCell>
                              <TableCell>
                                <Iconify
                                  onClick={() => {
                                    setEditIndex(i);
                                    openDelete();
                                  }}
                                  style={{ color: "red", cursor: "pointer" }}
                                  icon={"ic:baseline-delete"}
                                />
                              </TableCell>
                            </TableRow>
                          </>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Scrollbar>
            </Grid>
            <Grid item xs={12}>
              <div className="text-end pb-4">
                <LoadingButton
                  loading={loadingBtn}
                  variant="contained"
                  type="submit"
                >
                  Submit
                </LoadingButton>
              </div>
            </Grid>
          </Grid>
        </form>
      </Container>
      <Dialog
        open={addMenuitemDialogOpen}
        onClose={closeAddItemDialog}
        scroll="paper"
        maxWidth="sm"
        fullWidth
        disableEnforceFocus={true}
      >
        <DialogTitle style={{ padding: 0 }}>
          <div className="model-head ">
            <p>
              {isEditing
                ? "Edit Ready Solution Step"
                : "Add Ready Solution Step"}
            </p>
            <p onClick={closeAddItemDialog}>
              <Iconify icon="maki:cross" />
            </p>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid>
            <>
              <div>
                <form
                  className="gap-3 mt-3"
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (isEditing) {
                      handleEditData();
                    } else {
                      handleAddData();
                    }
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <FormControl fullWidth>
                        <TextField
                          value={newMenuItem.title}
                          label="title"
                          onChange={(e) =>
                            setNewMenuItem((prev) => {
                              return { ...prev, title: e.target.value };
                            })
                          }
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <RichEditor
                        value={newMenuItem.description}
                        setValue={(val) =>
                          setNewMenuItem((prev) => {
                            return {
                              ...prev,
                              description: val,
                            };
                          })
                        }
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl fullWidth>
                        <TextField
                          label="Learn More button Text"
                          required
                          // style={{ width: "48%" }}
                          onChange={(e) =>
                            setNewMenuItem((prev) => {
                              return {
                                ...prev,
                                learn_more_button: {
                                  ...prev.learn_more_button,
                                  text: e.target.value,
                                },
                              };
                            })
                          }
                          value={newMenuItem.learn_more_button.text}
                          name="title"
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl fullWidth>
                        <TextField
                          label="Learn More button link"
                          required
                          // style={{ width: "48%" }}
                          onChange={(e) =>
                            setNewMenuItem((prev) => {
                              return {
                                ...prev,
                                learn_more_button: {
                                  ...prev.learn_more_button,
                                  link: e.target.value,
                                },
                              };
                            })
                          }
                          value={newMenuItem.learn_more_button.link}
                          name="title"
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl fullWidth>
                        <TextField
                          label="Tab bar Text"
                          required
                          // style={{ width: "48%" }}
                          onChange={(e) =>
                            setNewMenuItem((prev) => {
                              return {
                                ...prev,
                                tab_bar_text: e.target.value,
                              };
                            })
                          }
                          value={newMenuItem.tab_bar_text}
                          name="title"
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      {(newMenuItem.tabBlob || newMenuItem.tab_bar_image) && (
                        <img
                          style={{
                            width: "17rem",
                            height: "9rem",
                            // marginLeft: "27rem",
                            marginTop: "1rem",
                          }}
                          src={
                            newMenuItem.tabBlob
                              ? newMenuItem.tabBlob
                              : s3baseUrl + newMenuItem.tab_bar_image
                          }
                          alt="svg"
                        />
                      )}
                      <label htmlFor="icon-button-file-tab">
                        <input
                          style={{ display: "none" }}
                          accept="image/*"
                          id="icon-button-file-tab"
                          type="file"
                          value=""
                          name="logo"
                          onChange={(e) =>
                            setNewMenuItem((prev) => {
                              return {
                                ...prev,
                                tabFile: e.target.files[0],
                                tabBlob: URL.createObjectURL(e.target.files[0]),
                              };
                            })
                          }
                        />
                        <Button
                          aria-label="upload picture"
                          component="span"
                          className="upload-button mt-3 "
                        >
                          {newMenuItem.tab_bar_image || newMenuItem.tabBlob
                            ? "Change Tab Image"
                            : "Upload Tab Image"}
                        </Button>
                      </label>
                    </Grid>
                    <Grid item xs={12}>
                      {(newMenuItem.blob || newMenuItem.image) && (
                        <img
                          style={{
                            width: "17rem",
                            height: "9rem",
                            // marginLeft: "27rem",
                            marginTop: "1rem",
                          }}
                          src={
                            newMenuItem.blob
                              ? newMenuItem.blob
                              : s3baseUrl + newMenuItem.image
                          }
                          alt="svg"
                        />
                      )}
                      <label htmlFor="icon-button-file">
                        <input
                          style={{ display: "none" }}
                          accept="image/*"
                          id="icon-button-file"
                          type="file"
                          value=""
                          name="logo"
                          onChange={(e) =>
                            setNewMenuItem((prev) => {
                              return {
                                ...prev,
                                file: e.target.files[0],
                                blob: URL.createObjectURL(e.target.files[0]),
                              };
                            })
                          }
                        />
                        <Button
                          aria-label="upload picture"
                          component="span"
                          className="upload-button mt-3 "
                        >
                          {newMenuItem.image || newMenuItem.blob
                            ? "Change Step Image"
                            : "Upload Step Image"}
                        </Button>
                      </label>
                    </Grid>
                  </Grid>

                  <div className="text-end mt-3">
                    <Button
                      variant="contained"
                      type="submit"
                      // onClick={(e) => HandleEditData(e)}
                    >
                      {isEditing ? "Edit" : "Add"}
                    </Button>
                  </div>
                </form>
              </div>
            </>
          </Grid>
        </DialogContent>
      </Dialog>
      <MuiDialog
        open={deleteLogoDialog}
        onToggle={closeDelete}
        title="Delete step"
        message="Are you sure you want to delete this step?"
        onAgree={confirmDelete}
      />
    </Page>
  );
}

export default WorkManagement;
